import { camelCase } from 'change-case'

export default {
  set ({ state, commit }, attr) {
    attr = attr || 'model'
    Object.keys(state[attr]).forEach((key) => {
      const keyChanged = camelCase(key)
      commit('setAttr', {
        name: keyChanged,
        value: state[attr][key]
      })
    })
  }
}
